module.exports = __webpack_public_path__ + "static/media/Esophagus.43301a44.ogg";